import { Canvas } from "@react-three/fiber"
import { CarModel, } from "./CarModel";
import { availableModels } from "../data/carData";
import { config } from "../config/config";
import { Suspense, useEffect, useRef, useState } from "react";
import { CameraHandler } from "./CameraHandler";
import { useDispatch } from "react-redux";
import { cameraActions } from "../redux/cameraSlice";
import { Room } from "./Room";
import { DebugComponents } from "./DebugComponents";
import classes from './Car3DView.module.scss';
import { InteractionElements } from "./CarInteractions";
import { AssetElements } from "./AssetElements";
import { PreviewActionButtons } from "./PreviewActionButtons";
import { Model3D } from "../models/Model3D";
import { useGLTF, useProgress } from "@react-three/drei";
// import { CarSelection } from "./CarSelection";

type Car3DViewProps = {
}

export const Car3DView = (props: Car3DViewProps) => {
  const [modelName, setModelName] = useState('mclaren');
  const [model, setModel] = useState<Model3D>();
  const dispatch = useDispatch();
  const [boundary, setBoundary] = useState<BoundarySpec>({});
  const [isLoading, setIsLoading] = useState(false);
  const { progress } = useProgress();

  useEffect(() => {
    setModel(availableModels[modelName]);
  }, [modelName])

  useEffect(() => {
    setIsLoading(progress !== 100);
  }, [progress])

  useEffect(() => {
    if (!model?.metadata.initialViewPoint) {
      return;
    }
    setBoundary({
      exclusion: model.metadata.boundary?.exclusion || {
        center: [0, 1, 0],
        dimension: [4, 2, 7],
      },
      inclusion: model.metadata.boundary?.inclusion || {
        center: [0, 5.1, 0],
        dimension: [20, 10, 20]
      }
    })
  }, [dispatch, model])

  if (!model) {
    return null;
  }

  return <div
    className={classes.container}>
    <Canvas
      shadows
      dpr={[1, 1.5]}
    >
      <Suspense fallback={null} >
        <Room />
        <CameraHandler
          initialViewPoint={model.metadata.initialViewPoint}
          baseBoundary={boundary}
        />
        {model.metadata.interactions && <InteractionElements interactions={model.metadata.interactions} />}
        {model.metadata.assets && <AssetElements metadatas={model.metadata.assets} />}
        <DebugComponents />
      </Suspense>
    </Canvas>
    {/* <CarSelection value={modelName} onChange={setModelName} /> */}
    {isLoading && <div className={classes.loadingOverlay}>
      Loading model...
    </div>}
    <PreviewActionButtons />
  </div>
}

